var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#0FADFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.706 25.107a1.033 1.033 0 011.05-1.05l1.594.019a3.1 3.1 0 003.15-3.15 3.28 3.28 0 00-3.225-3.225l-1.594-.02a1.093 1.093 0 01-1.075-1.074 1.033 1.033 0 011.05-1.05l1.594.018c2.934.035 5.34 2.442 5.375 5.376a5.164 5.164 0 01-5.25 5.25l-1.594-.02a1.093 1.093 0 01-1.075-1.074zm-7.856-1.131a1.093 1.093 0 011.075 1.075 1.033 1.033 0 01-1.05 1.05l-2.125-.025c-2.934-.035-5.34-2.441-5.375-5.375a5.164 5.164 0 015.25-5.25l2.125.025a1.093 1.093 0 011.075 1.075 1.033 1.033 0 01-1.05 1.05l-2.125-.025a3.098 3.098 0 00-3.15 3.15 3.28 3.28 0 003.225 3.225zm5.808-11.309c-.657-.632-1.352-.424-1.554.465l-1.276 5.632-1.276 5.633c-.201.889.168 2.121.825 2.753.656.632 1.352.424 1.553-.465l2.552-11.265c.201-.889-.168-2.121-.824-2.753z"
  })));
}
export default SvgEmbed;